import { gql } from "@apollo/client";
import { BRANCH_INFO } from "../fragments";

export const CREATE_BRANCH = gql`
  mutation createBranch($name: String!, $branchLink: String) {
    createBranch(name: $name, branchLink: $branchLink) {
      ...branchInfo
    }
  }
  ${BRANCH_INFO}
`;

export const UPDATE_BRANCH = gql`
  mutation updateBranch($id: ID!, $name: String!, $branchLink: String) {
    updateBranch(id: $id, name: $name, branchLink: $branchLink) {
      ...branchInfo
    }
  }
  ${BRANCH_INFO}
`;

export const DISABLE_BRANCH = gql`
  mutation disableBranch($id: ID!, $sst: Boolean!) {
    disableBranch(id: $id, sst: $sst) {
      ...branchInfo
    }
  }
  ${BRANCH_INFO}
`;
